import { render, staticRenderFns } from "./Top10Staff.vue?vue&type=template&id=68d5a4b1"
import script from "./Top10Staff.vue?vue&type=script&lang=js"
export * from "./Top10Staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d5a4b1')) {
      api.createRecord('68d5a4b1', component.options)
    } else {
      api.reload('68d5a4b1', component.options)
    }
    module.hot.accept("./Top10Staff.vue?vue&type=template&id=68d5a4b1", function () {
      api.rerender('68d5a4b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/Top10Staff.vue"
export default component.exports